/*
 * TCC Product Waitlist
 * Shows "Join the Waitlist" when the selected variant is unavailable and opens an accessible
 * signup dialog. On submit it sends, using only the PUBLIC Klaviyo site ID:
 *   1. a variant-level back-in-stock subscription  POST /client/back-in-stock-subscriptions
 *   2. a "Joined Product Waitlist" event            POST /client/events
 *   3. only if the shopper ticks the optional box, an email-marketing subscription to the
 *      chosen Klaviyo list                             POST /client/subscriptions
 *   4. only if the shopper chooses text alerts and ticks the SMS consent box, an SMS-marketing
 *      subscription to the SMS list (double opt-in: Klaviyo texts them to reply Y)
 * Purchasing for available variants is untouched: the native Add to cart button is only hidden
 * while the selected variant is unavailable.
 */
(function () {
  if (customElements.get('tcc-waitlist')) return;

  var KLAVIYO = 'https://a.klaviyo.com';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    var b = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(b);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var h = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
  }

  /* US numbers may be typed in any common format; other countries must start with + and the country code. */
  function toE164(raw) {
    var s = (raw || '').trim();
    if (!s) return '';
    var plus = s.charAt(0) === '+';
    var d = s.replace(/\D/g, '');
    if (plus && d.charAt(0) !== '1') return d.length >= 8 && d.length <= 15 ? 'INTL' : null;
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    return null;
  }

  /* Order attribution: shoppers arriving from the Klaviyo restock email (utm_content=tcc-waitlist)
     get a hidden cart attribute, which Shopify copies onto the order. A Shopify Flow workflow
     then tags those orders "tcc-waitlist". Runs once per browser session. */
  (function markWaitlistVisit() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('utm_content') !== 'tcc-waitlist') return;
      if (window.sessionStorage && sessionStorage.getItem('tccWaitlistMarked') === '1') return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _tcc_source: 'tcc-waitlist', _tcc_campaign: params.get('utm_campaign') || '' } })
      }).then(function (res) {
        if (res.ok && window.sessionStorage) sessionStorage.setItem('tccWaitlistMarked', '1');
      }).catch(function () {});
    } catch (e) {}
  })();

  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }

  class TccWaitlist extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.data = readJSON(this, 'script[data-wl-product]');
      this.strings = readJSON(this, 'script[data-wl-strings]');
      this.dialog = this.querySelector('[data-wl-dialog]');
      this.form = this.querySelector('[data-wl-form]');
      this.submitBtn = this.querySelector('[data-wl-submit]');
      this.live = this.querySelector('[data-wl-live]');
      this.smsEnabled = this.dataset.smsEnabled === 'true';
      this.optinWrap = this.querySelector('[data-wl-optin]');
      this.smsConsentWrap = this.querySelector('[data-wl-sms-consent]');
      this.busy = false;
      this.submissionId = null;
      this.done = {};

      var variants = this.data.variants || [];
      this.byId = {};
      for (var i = 0; i < variants.length; i++) this.byId[String(variants[i].id)] = variants[i];

      this.productInfo = this.closest('product-info') || document;
      this.productForm = this.closest('[data-tcc-buy]') || this.parentElement;

      this.setVariant(this.byId[String(this.data.currentVariantId)] || null, true);

      this.querySelector('[data-wl-open]').addEventListener('click', this.open.bind(this));
      this.querySelectorAll('[data-wl-close]').forEach(function (b) { b.addEventListener('click', this.close.bind(this)); }, this);
      this.dialog.addEventListener('click', function (e) { if (e.target === this.dialog) this.close(); }.bind(this));
      this.dialog.addEventListener('close', this.onClosed.bind(this));
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      this.form.addEventListener('change', this.syncChannels.bind(this));
      this.form.addEventListener('input', function (e) {
        if (e.target.name) this.clearError(e.target.name);
        if (e.target.name === 'phone') this.syncChannels();
      }.bind(this));
      this.syncChannels();

      /* Dawn publishes variant-change with the selected variant (or null when the combination does not exist). */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var d = event && event.data;
          if (!d || (d.sectionId && d.sectionId !== this.dataset.sectionId)) return;
          this.setVariant(d.variant ? (this.byId[String(d.variant.id)] || d.variant) : null, false, !d.variant);
        }.bind(this));
      }
      /* Fallback for selectors that do not publish: read the form's hidden variant input after a change. */
      this.productInfo.addEventListener('change', function (e) {
        if (!e.target.closest || !e.target.closest('variant-selects')) return;
        setTimeout(this.syncFromInput.bind(this), 400);
      }.bind(this));
    }

    disconnectedCallback() { if (this.unsub) this.unsub(); }

    syncFromInput() {
      var input = this.productInfo.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      if (!input || !input.value) return;
      var v = this.byId[String(input.value)];
      if (v && (!this.variant || String(this.variant.id) !== String(v.id))) this.setVariant(v);
    }

    /* unknown = the chosen option combination has no variant at all. We do not offer a waitlist for that. */
    setVariant(v, initial, unknown) {
      var live = v ? (this.byId[String(v.id)] || v) : null;
      if (live && v && typeof v.available === 'boolean') live.available = v.available;
      this.variant = live;
      var show = !!(live && live.available === false && !unknown);
      this.hidden = !show;
      if (this.productForm && this.productForm.classList) this.productForm.classList.toggle('tcc-pwl-active', show);
      if (!initial && this.dialog.open && !show) this.close();
      this.submissionId = null;
      this.renderProduct();
    }

    renderProduct() {
      var v = this.variant;
      var img = this.querySelector('[data-wl-img]');
      var src = (v && v.image) || this.data.productImage;
      if (src) { img.src = src; img.alt = ''; img.hidden = false; } else { img.hidden = true; }
      var vEl = this.querySelector('[data-wl-variant]');
      var showTitle = v && !this.data.hasOnlyDefaultVariant && v.title && v.title !== 'Default Title';
      var parts = [];
      if (showTitle) parts.push((this.strings.variantPrefix ? this.strings.variantPrefix + ' ' : '') + v.title);
      if (this.strings.limitedNote) parts.push(this.strings.limitedNote);
      vEl.textContent = parts.join(' \u00b7 ');
      vEl.hidden = !parts.length;
    }

    open() {
      if (!this.variant) return;
      this.renderProduct();
      this.showView('form');
      this.opener = document.activeElement;
      if (!this.submissionId) this.submissionId = uuid();
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
      document.documentElement.classList.add('tcc-pwl-lock');
      var first = this.form.querySelector('input[name="email"]');
      if (first) first.focus();
    }

    close() {
      if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close(); else { this.dialog.removeAttribute('open'); this.onClosed(); }
    }

    onClosed() {
      document.documentElement.classList.remove('tcc-pwl-lock');
      if (this.opener && this.opener.focus) this.opener.focus();
    }

    showView(name) {
      this.querySelectorAll('[data-wl-view]').forEach(function (el) { el.hidden = el.dataset.wlView !== name; });
    }

    marketingOptIn() {
      var box = this.form && this.form.elements.marketing;
      return !!(box && box.checked && this.dataset.marketingEnabled === 'true' && this.dataset.marketingList);
    }

    /* Email marketing consent, sent only when the shopper ticked the box. Email only, never SMS. */
    subscribeMarketing(email) {
      var list = this.dataset.marketingList;
      var build = function (withConsent) {
        var attrs = { email: email };
        if (withConsent) attrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
        return {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Product waitlist opt-in',
              profile: { data: { type: 'profile', attributes: attrs } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        };
      };
      /* Retry in the older documented shape if this API revision rejects the consent block. */
      return this.post('/client/subscriptions', build(true)).catch(function (err) {
        if (err && err.status === 400) return this.post('/client/subscriptions', build(false));
        throw err;
      }.bind(this));
    }

    /* SMS marketing consent, sent only when the shopper chose text alerts and ticked the consent box.
       Phone only, so email consent is never changed here. The SMS list uses double opt-in. */
    subscribeSms(phone) {
      var list = this.dataset.smsList;
      var build = function (withConsent) {
        var attrs = { phone_number: phone };
        if (withConsent) attrs.subscriptions = { sms: { marketing: { consent: 'SUBSCRIBED' } } };
        var body = { data: { type: 'subscription', attributes: { custom_source: 'Product waitlist text alerts', profile: { data: { type: 'profile', attributes: attrs } } } } };
        if (list) body.data.relationships = { list: { data: { type: 'list', id: list } } };
        return body;
      };
      return this.post('/client/subscriptions', build(true)).catch(function (err) {
        if (err && err.status === 400) return this.post('/client/subscriptions', build(false));
        throw err;
      }.bind(this));
    }

    /* Email is always the alert channel. A text alert is added when the shopper types a mobile number. */
    channels() {
      var ch = ['EMAIL'];
      var phone = this.form.elements.phone;
      if (this.smsEnabled && phone && (phone.value || '').trim()) ch.push('SMS');
      return ch;
    }

    syncChannels() {
      var hasPhone = this.channels().indexOf('SMS') > -1;
      if (this.smsConsentWrap) {
        this.smsConsentWrap.hidden = !hasPhone;
        if (!hasPhone && this.form.elements.sms_consent) { this.form.elements.sms_consent.checked = false; this.clearError('sms_consent'); }
      }
      if (!hasPhone) this.clearError('phone');
    }

    setError(name, msg) {
      var el = this.querySelector('[data-wl-error="' + name + '"]');
      if (!el) return;
      el.textContent = msg; el.hidden = false;
      var input = this.form.elements[name];
      if (input && input.setAttribute) input.setAttribute('aria-invalid', 'true');
    }

    clearError(name) {
      var el = this.querySelector('[data-wl-error="' + name + '"]');
      if (el) { el.textContent = ''; el.hidden = true; }
      var input = this.form.elements[name];
      if (input && input.removeAttribute) input.removeAttribute('aria-invalid');
    }

    validate() {
      ['email', 'phone', 'sms_consent', 'form'].forEach(this.clearError, this);
      var ch = this.channels();
      var out = { channels: ch, email: '', phone: '' };
      var firstBad = null;
      out.email = (this.form.elements.email.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(out.email)) { this.setError('email', this.strings.errEmail); firstBad = firstBad || this.form.elements.email; }
      if (ch.indexOf('SMS') > -1) {
        out.phone = toE164(this.form.elements.phone.value);
        if (out.phone === 'INTL') { out.phone = ''; this.setError('phone', this.strings.errPhoneRegion); firstBad = firstBad || this.form.elements.phone; }
        else if (!out.phone) { this.setError('phone', this.strings.errPhone); firstBad = firstBad || this.form.elements.phone; }
        var consentBox = this.form.elements.sms_consent;
        if (consentBox && !consentBox.checked) { this.setError('sms_consent', this.strings.errSmsConsent); firstBad = firstBad || consentBox; }
      }
      if (firstBad) { firstBad.focus(); return null; }
      return out;
    }

    setBusy(on) {
      this.busy = on;
      this.submitBtn.disabled = on;
      this.submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      this.querySelector('[data-wl-submit-label]').hidden = on;
      this.querySelector('[data-wl-loading]').hidden = !on;
    }

    post(path, body) {
      var url = KLAVIYO + path + '?company_id=' + encodeURIComponent(this.dataset.siteId);
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: this.dataset.revision },
        body: JSON.stringify(body)
      }).then(function (res) {
        if (res.ok) return true;
        return res.text().then(function (t) {
          var err = new Error('Klaviyo ' + res.status);
          err.status = res.status; err.body = t;
          throw err;
        });
      });
    }

    profile(input) {
      var a = {};
      if (input.email) a.email = input.email;
      if (input.phone) a.phone_number = input.phone;
      return { data: { type: 'profile', attributes: a } };
    }

    onSubmit(e) {
      e.preventDefault();
      if (this.busy) return;
      var input = this.validate();
      if (!input) return;
      var v = this.variant;
      if (!v) return;

      var optIn = !!input.email && this.marketingOptIn();
      var smsOptIn = !!input.phone;
      var key = [v.id, input.email, input.phone, input.channels.join('+'), optIn ? 'mkt' : ''].join('|');
      if (this.done[key]) { this.success(); return; }

      if (!this.submissionId) this.submissionId = uuid();
      var sid = this.submissionId;
      var now = new Date().toISOString();
      var productUrl = this.dataset.shopUrl + this.data.productUrl + '?variant=' + v.id;

      var bis = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: { profile: this.profile(input), channels: input.channels },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } } }
        }
      };

      var props = {
        ProductID: String(this.data.productId),
        VariantID: String(v.id),
        ProductTitle: this.data.productTitle,
        VariantTitle: v.title,
        ProductURL: productUrl,
        ImageURL: v.image || this.data.productImage || undefined,
        SignupSource: this.dataset.source,
        SignupPage: window.location.href.split('#')[0],
        SignupTimestamp: now,
        NotificationChannels: input.channels,
        SubmissionID: sid,
        EmailMarketingOptIn: optIn,
        SmsMarketingOptIn: smsOptIn
      };
      if (v.sku) props.SKU = v.sku;

      var evt = {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            time: now,
            unique_id: sid,
            metric: { data: { type: 'metric', attributes: { name: this.dataset.eventName } } },
            profile: this.profile(input)
          }
        }
      };

      this.setBusy(true);
      this.post('/client/back-in-stock-subscriptions', bis)
        .then(function () {
          /* The interest event is recorded after the subscription succeeds. A failure here must not
             show the shopper an error, because their back-in-stock alert is already in place. */
          var jobs = [this.post('/client/events', evt).catch(function (err) {
            if (window.console) console.warn('[tcc-waitlist] event not recorded', err && err.status, err && err.body);
          })];
          if (smsOptIn) {
            jobs.push(this.subscribeSms(input.phone).then(function () { this.smsPending = true; }.bind(this)).catch(function (err) {
              if (window.console) console.warn('[tcc-waitlist] text opt-in not recorded', err && err.status, err && err.body);
            }));
          }
          if (optIn) {
            jobs.push(this.subscribeMarketing(input.email).then(function () { this.optedIn = true; }.bind(this)).catch(function (err) {
              if (window.console) console.warn('[tcc-waitlist] marketing opt-in not recorded', err && err.status, err && err.body);
            }));
          }
          return Promise.all(jobs);
        }.bind(this))
        .then(function () {
          this.done[key] = true;
          this.submissionId = null;
          this.success();
        }.bind(this))
        .catch(function (err) {
          if (window.console) console.error('[tcc-waitlist] subscription failed', err && err.status, err && err.body);
          this.setError('form', this.strings.errGeneric);
        }.bind(this))
        .finally(function () { this.setBusy(false); }.bind(this));
    }

    success() {
      this.showView('success');
      var view = this.querySelector('[data-wl-view="success"]');
      var msg = this.strings.successText || '';
      if (this.optedIn && this.strings.successOptIn) msg = msg + ' ' + this.strings.successOptIn;
      if (this.smsPending && this.strings.successSms) msg = msg + ' ' + this.strings.successSms;
      var textEl = this.querySelector('[data-wl-success-text]');
      if (textEl) textEl.textContent = msg;
      if (this.live) this.live.textContent = msg;
      if (view) view.focus();
      try { document.dispatchEvent(new CustomEvent('tcc:waitlist:joined', { detail: { variantId: this.variant && this.variant.id } })); } catch (e) {}
    }
  }

  customElements.define('tcc-waitlist', TccWaitlist);
})();
